/**
 * Energy Drop × Horizon
 * Comportamiento de las secciones propias: galería, paquetes de producto, precios,
 * cuenta atrás, entrega estimada, carrusel, porcentajes animados y cuenta atrás del carrito.
 * El carrito (cajón, contador, descuentos...) es el de Horizon: este archivo solo le avisa
 * con sus mismos eventos cuando se añade algo.
 */
const CFG = window.EnergyDrop || { routes: { cart: '/cart', cartAdd: '/cart/add.js' } };
const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

/* ---------- dinero ----------
 * Los precios llegan en unidades menores (centavos) y YA convertidos por Shopify a la divisa
 * activa (Mercados). Para escribirlos igual que lo hace Liquid ("$49.900,00 COP"), el tema
 * imprime un número de muestra con el filtro money_with_currency (CFG.moneyProbe) y de él
 * se aprenden el prefijo, los separadores, los decimales y el código de la divisa activa.
 * Así el JavaScript y el HTML del servidor siempre muestran el mismo formato y la misma divisa. */
const ZERO_DECIMALS = ['BIF', 'BYR', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW', 'PYG', 'RWF', 'UGX', 'UYI', 'VND', 'VUV', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XTS', 'XUA'];
const THREE_DECIMALS = ['BHD', 'IQD', 'JOD', 'KWD', 'LYD', 'OMR', 'TND'];
function minorDigits(code) {
  code = String(code || '').toUpperCase();
  if (ZERO_DECIMALS.indexOf(code) > -1) return 0;
  if (THREE_DECIMALS.indexOf(code) > -1) return 3;
  if (code === 'CLF' || code === 'UYW') return 4;
  if (code === 'MRO') return 5;
  return 2;
}
/** Aprende el formato de la divisa activa a partir del número de muestra que imprime Liquid. */
function parseProbe(probe) {
  const str = String(probe || '');
  const first = str.search(/\d/);
  if (first < 0) return null;
  let last = str.length - 1;
  while (last > first && !/\d/.test(str[last])) last--;
  const num = str.slice(first, last + 1);
  const seps = num.replace(/\d/g, '').split('');
  let thousands = '', decimal = '', decimals = 0;
  if (seps.length) {
    const lastSep = seps[seps.length - 1];
    const trailing = num.length - num.lastIndexOf(lastSep) - 1;
    const distinct = seps.filter((c, i) => seps.indexOf(c) === i);
    const count = seps.filter((c) => c === lastSep).length;
    if (distinct.length > 1) { decimal = lastSep; thousands = distinct.filter((c) => c !== lastSep)[0]; decimals = trailing; }
    else if (count === 1 && trailing !== 3) { decimal = lastSep; decimals = trailing; }
    else thousands = lastSep;
  }
  return { prefix: str.slice(0, first), suffix: str.slice(last + 1), thousands, decimal, decimals };
}
/** Escribe un precio en un nodo SOLO si los centavos cambiaron respecto a lo que ya muestra.
 *  Si no cambió (lo normal al elegir otro color), no se toca el texto: así se conserva lo que
 *  imprimió el servidor y lo que convirtió Bucks a la divisa del cliente. */
function setMoney(el, cents) {
  cents = Math.round(+cents || 0);
  if (!el || el.getAttribute('data-ed-cents') === String(cents)) return;
  el.setAttribute('data-ed-cents', String(cents));
  el.innerHTML = '<bdi></bdi>';
  el.firstChild.textContent = formatMoney(cents);
  document.dispatchEvent(new CustomEvent('ed:price-updated', { detail: { el, cents } }));
}
const MONEY = parseProbe(CFG.moneyProbe);
const CURRENCY = String(CFG.currency || '').toUpperCase();

function formatMoney(cents) {
  cents = Math.round(+cents || 0);
  const digits = minorDigits(CURRENCY);
  if (!MONEY) {
    /* Último recurso (no debería ocurrir): Intl con el código de la divisa activa */
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: CURRENCY, currencyDisplay: 'code' }).format(cents / Math.pow(10, digits));
    } catch (e) { return (cents / Math.pow(10, digits)).toFixed(digits) + ' ' + CURRENCY; }
  }
  const d = MONEY.decimals;
  /* aritmética entera: nada de errores de coma flotante */
  const scaled = d <= digits ? Math.round(cents / Math.pow(10, digits - d)) : cents * Math.pow(10, d - digits);
  const str = String(scaled).padStart(d + 1, '0');
  let whole = d ? str.slice(0, -d) : str;
  const frac = d ? str.slice(-d) : '';
  if (MONEY.thousands) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.thousands);
  return MONEY.prefix + whole + (d ? MONEY.decimal + frac : '') + MONEY.suffix;
}

/* ---------- galería ---------- */
function initGallery(g) {
  if (g._edInit) return;
  g._edInit = true;
  const track = $('[data-ed-gallery-track]', g);
  const thumbs = $$('.ed-gallery__thumb', g);
  const slides = $$('.ed-gallery__slide', track);
  const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.index)));
  track.addEventListener('scroll', () => {
    const i = Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((t, k) => t.classList.toggle('ed-is-active', k === i));
  }, { passive: true });
  g._goToMedia = (id) => {
    for (let i = 0; i < slides.length; i++) if (slides[i].dataset.mediaId === String(id)) { go(i); return; }
  };
}

/* ---------- formulario de producto: paquetes, precios, añadir al carrito ---------- */
const unitsOf = (form) => {
  const bundles = $('[data-ed-bundles]', form);
  if (bundles) {
    const sel = $('.ed-bundle.ed-is-selected', bundles) || $('.ed-bundle', bundles);
    return $$('[data-ed-unit]', sel);
  }
  return $$('[data-ed-unit]', form);
};
const optOf = (u) => (u.tagName === 'SELECT' ? u.options[u.selectedIndex] : u);
const num = (el, key) => +el.getAttribute('data-ed-' + key) || 0;

function updatePrices(form) {
  $$('[data-ed-bundle]', form).forEach((card) => {
    const d = num(card, 'discount');
    let sum = 0, cmp = 0;
    $$('[data-ed-unit]', card).forEach((u) => {
      const o = optOf(u), p = num(o, 'price'), c = num(o, 'compare');
      sum += p; cmp += Math.max(c, p);
    });
    const total = Math.round(sum * (100 - d) / 100);
    const t = $('[data-ed-bundle-total]', card), w = $('[data-ed-bundle-was]', card);
    if (t) setMoney(t, total);
    if (w) { if (cmp > total) { setMoney(w, cmp); w.hidden = false; } else w.hidden = true; }
  });
  const first = unitsOf(form)[0];
  if (first) {
    const o = optOf(first), p = num(o, 'price'), c = num(o, 'compare');
    const now = $('[data-ed-price-now]', form), was = $('[data-ed-price-was]', form), badge = $('[data-ed-price-badge]', form);
    if (now) setMoney(now, p);
    if (was && badge) {
      if (c > p) { setMoney(was, c); badge.textContent = '-' + Math.round((c - p) * 100 / c) + '%'; was.hidden = badge.hidden = false; }
      else was.hidden = badge.hidden = true;
    }
  }
}

function getItems(form) {
  const map = {};
  unitsOf(form).forEach((u) => { if (u.value) map[u.value] = (map[u.value] || 0) + 1; });
  if (!Object.keys(map).length) { const id = $('[name=id]', form); if (id) map[id.value] = 1; }
  return Object.keys(map).map((id) => ({ id: +id, quantity: map[id] }));
}

let eventsLib = null;
async function loadEvents() {
  if (eventsLib !== null) return eventsLib;
  try { eventsLib = await import('@shopify/events'); } catch (e) { eventsLib = false; }
  return eventsLib;
}

/** Añade al carrito avisando al cajón de Horizon con sus mismos eventos. */
async function addToCart(form, items) {
  const lib = await loadEvents();
  const sectionIds = $$('cart-items-component').map((c) => c.dataset.sectionId).filter(Boolean);
  const itemCount = items.reduce((a, i) => a + i.quantity, 0);
  let deferred = null;

  if (lib && lib.CartLinesUpdateEvent && lib.CartLinesUpdateEvent.createPromise) {
    deferred = lib.CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new lib.CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise
    }));
  }

  const body = { items };
  if (sectionIds.length) body.sections = sectionIds.join(',');

  try {
    const res = await fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'No se pudo añadir al carrito');

    if (deferred) {
      const comp = $('cart-items-component');
      let cart;
      try {
        cart = comp && comp.fetchCartData ? await comp.fetchCartData()
          : await fetch(CFG.routes.cart + '.json', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      } catch (e) { cart = await fetch(CFG.routes.cart + '.json').then((r) => r.json()); }
      deferred.resolve({
        cart: lib.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items, source: 'product-form-component', sourceId: form.id || 'ed-product-form',
          itemCount, productId: form.dataset.productId, sections: json.sections, didError: false
        }
      });
    } else {
      window.location.assign(CFG.routes.cart);
    }
    return json;
  } catch (err) {
    if (deferred) {
      try { deferred.reject(err); } catch (e) { /* noop */ }
    }
    throw err;
  }
}

function initProductForm(form) {
  if (form._edInit) return;
  form._edInit = true;
  const err = $('[data-ed-buy-error]', form);
  const gallery = $('[data-ed-gallery]');
  const showErr = (m) => { if (err) { err.textContent = m; err.hidden = !m; } };

  $$('[data-ed-bundle]', form).forEach((card) => {
    const radio = $('.ed-bundle__radio', card);
    card.addEventListener('click', () => {
      $$('[data-ed-bundle]', form).forEach((c) => c.classList.toggle('ed-is-selected', c === card));
      radio.checked = true;
      updatePrices(form);
    });
    radio.addEventListener('change', () => card.click());
  });
  form.addEventListener('change', (e) => {
    if (e.target.matches('select[data-ed-unit]')) {
      updatePrices(form);
      const o = e.target.options[e.target.selectedIndex];
      const media = o.getAttribute('data-ed-media');
      if (gallery && gallery._goToMedia && media) gallery._goToMedia(media);
    }
  });
  updatePrices(form);

  const setLoading = (btn, on) => { if (btn) { btn.disabled = on; btn.style.opacity = on ? 0.6 : ''; } };
  form.addEventListener('submit', (e) => {
    e.preventDefault(); showErr('');
    const btn = $('[data-ed-add]', form); setLoading(btn, true);
    addToCart(form, getItems(form))
      .catch((er) => showErr(er.message))
      .then(() => setLoading(btn, false));
  });
  const buy = $('[data-ed-buy-now]', form);
  if (buy) buy.addEventListener('click', () => {
    showErr(''); setLoading(buy, true);
    fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: getItems(form) })
    }).then((r) => r.json().then((j) => {
      if (!r.ok || j.status) throw new Error(j.description || j.message || 'No se pudo añadir al carrito');
      window.location.href = '/checkout';
    })).catch((er) => { showErr(er.message); setLoading(buy, false); });
  });
}

/* ---------- cuenta atrás (urgencia) ---------- */
function initCountdown(box) {
  if (box._edInit) return;
  box._edInit = true;
  const end = new Date(box.getAttribute('data-ed-countdown')).getTime();
  const out = $('[data-ed-countdown-output]', box);
  if (isNaN(end) || !out) return;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const s = Math.floor((end - Date.now()) / 1000);
    if (s <= 0) { out.hidden = true; clearInterval(iv); return; }
    const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
    out.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s % 60);
  };
  const iv = setInterval(tick, 1000); tick();
}

/* ---------- entrega estimada ---------- */
function addBusinessDays(date, n) {
  const d = new Date(date); let added = 0;
  while (added < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) added++; }
  return d;
}
function initDelivery(box) {
  const min = +box.getAttribute('data-ed-min') || 1, max = +box.getAttribute('data-ed-max') || min;
  const tpl = box.getAttribute('data-ed-template') || '{start} - {end}';
  const loc = document.documentElement.lang || undefined;
  const f = (d) => d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short' });
  const now = new Date();
  const out = $('[data-ed-delivery-text]', box);
  if (out) out.textContent = tpl.replace('{start}', f(addBusinessDays(now, min))).replace('{end}', f(addBusinessDays(now, max)));
}

/* ---------- carrusel ---------- */
function initCarousel(c) {
  if (c._edInit) return;
  c._edInit = true;
  const track = $('[data-ed-carousel-track]', c);
  const step = () => { const card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 18 : 300; };
  const p = $('[data-ed-carousel-prev]', c), n = $('[data-ed-carousel-next]', c);
  if (p) p.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  if (n) n.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
}

/* ---------- porcentajes animados ---------- */
function countUp(el) {
  const target = +el.getAttribute('data-ed-count'); let t0 = null;
  const step = (ts) => {
    if (!t0) t0 = ts;
    const k = Math.min((ts - t0) / 1300, 1);
    el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))) + '%';
    if (k < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
let barObserver = null;
function initBars() {
  const bars = $$('.ed-bar:not([data-ed-seen])');
  if (!bars.length) return;
  if ('IntersectionObserver' in window) {
    barObserver = barObserver || new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('ed-is-visible');
          const b = $('[data-ed-count]', en.target); if (b) countUp(b);
          barObserver.unobserve(en.target);
        }
      });
    }, { threshold: 0.35 });
    bars.forEach((b) => { b.setAttribute('data-ed-seen', ''); barObserver.observe(b); });
  } else bars.forEach((b) => b.classList.add('ed-is-visible'));
}

/* ---------- cuenta atrás del carrito (cajón de Horizon) ---------- */
let cartTimerExpired = false;
function cartTimerTick() {
  const boxes = $$('[data-ed-cart-timer]');
  if (!boxes.length) return;
  if (cartTimerExpired) { boxes.forEach((box) => { box.hidden = true; }); return; }
  const mins = CFG.cartTimerMinutes || 10, key = 'edCartTimerEnd';
  let end = 0;
  try { end = +sessionStorage.getItem(key); } catch (e) { /* noop */ }
  if (!end || end < Date.now()) {
    end = Date.now() + mins * 60000;
    try { sessionStorage.setItem(key, end); } catch (e) { /* noop */ }
  }
  const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
  const txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  boxes.forEach((box) => { const o = $('[data-ed-cart-timer-output]', box); if (o) o.textContent = txt; });
  if (left <= 0) {
    cartTimerExpired = true;
    boxes.forEach((box) => { box.hidden = true; });
    try { sessionStorage.removeItem(key); } catch (e) { /* noop */ }
  }
}

/* ---------- carrusel de reseñas (cambia solo cada N segundos) ---------- */
function initReviews(box) {
  if (box._edInit) return;
  box._edInit = true;
  const slides = $$('[data-ed-review-slide]', box);
  const dots = $$('[data-ed-review-dot]', box);
  if (slides.length < 2) return;
  const secs = Math.max(1, +box.dataset.interval || 2);
  let i = 0, timer = null, paused = false;
  const show = (n) => {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('ed-is-active', k === i));
    dots.forEach((d, k) => d.classList.toggle('ed-is-active', k === i));
  };
  const start = () => { stop(); timer = setInterval(() => { if (!paused) show(i + 1); }, secs * 1000); };
  const stop = () => { if (timer) clearInterval(timer); timer = null; };
  dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
  box.addEventListener('mouseenter', () => { paused = true; });
  box.addEventListener('mouseleave', () => { paused = false; });
  let x0 = null;
  box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); start(); }
  }, { passive: true });
  /* en el editor de temas: al seleccionar una reseña se muestra y se pausa */
  document.addEventListener('shopify:block:select', (e) => {
    const k = slides.indexOf(e.target);
    if (k > -1) { show(k); stop(); }
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    if (slides.indexOf(e.target) > -1) start();
  });
  start();
}

/* ---------- arranque (y recarga en el editor de temas) ---------- */
function initAll(root) {
  $$('[data-ed-gallery]', root).forEach(initGallery);
  $$('[data-ed-product-form]', root).forEach(initProductForm);
  $$('[data-ed-countdown]', root).forEach(initCountdown);
  $$('[data-ed-delivery]', root).forEach(initDelivery);
  $$('[data-ed-carousel]', root).forEach(initCarousel);
  $$('[data-ed-reviews]', root).forEach(initReviews);
  initBars();
}
initAll(document);
setInterval(cartTimerTick, 1000);
cartTimerTick();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
